import { useTranslation } from "react-i18next";

import DeploymentsIcon from "@/icons/deployments.svg?react";
import DevicesIcon from "@/icons/devices.svg?react";
import HomeIcon from "@/icons/home.svg?react";
import RingsIcon from "@/icons/rings.svg?react";
import SoftwareManagementIcon from "@/icons/software_management.svg?react";

import { Navigation } from "./Navigation";

export const MenuNavigation = () => {
  const { t } = useTranslation();

  const items = [
    {
      icon: <HomeIcon />,
      label: t("home.nav-item.label"),
      url: "/",
      exact: true,
      id: "home"
    },
    {
      icon: <SoftwareManagementIcon />,
      label: t("software-management.nav-item.label"),
      // We have to be here always under /fota/ because it's MAIN MIFE part
      url: "/fota/software-packages",
      id: "softwarePackages"
    },
    {
      icon: <DeploymentsIcon />,
      label: t("deployments.nav-item.label"),
      url: "/fota/deployments",
      id: "deployments"
    },
    {
      icon: <RingsIcon />,
      label: t("deployment-rings.nav-item.label"),
      url: "/fota/deployment-rings",
      id: "deploymentRings"
    },
    {
      icon: <DevicesIcon />,
      label: t("all-devices.nav-item.label"),
      url: "/fota/devices",
      id: "devices"
    }
  ];

  return <Navigation items={items} />;
};
